export const SITE_URL = 'https://admin.mswhyd.com';
//export const SITE_URL = 'http://127.0.0.1:8000'
